import { styled } from 'styled-components';
import { BonusItem } from '../../styles';

const BonusItemBurns = styled(BonusItem)`
  height: 100%;
  border-radius: 0;
  padding: 16px;
`;

export { BonusItemBurns };
